module.exports = __webpack_public_path__ + "img/icon_map_8_off_110.338806e7.png";